import * as classNames from 'classnames'
import * as React from 'react'
import { DAYS_OF_WEEK } from '../../../../state/constants/index'
import { capitalToUpperCase } from '../../../../utils/index'

interface IDaysOfWeekProps {
  days: DAYS_OF_WEEK[]
  id: string
  onDayClick: (day: DAYS_OF_WEEK) => void
}

const DaysOfWeek = (props: IDaysOfWeekProps) => {
  const daysOfWeek = [
    DAYS_OF_WEEK.SUNDAY,
    DAYS_OF_WEEK.MONDAY,
    DAYS_OF_WEEK.TUESDAY,
    DAYS_OF_WEEK.WEDNESDAY,
    DAYS_OF_WEEK.THURSDAY,
    DAYS_OF_WEEK.FRIDAY,
    DAYS_OF_WEEK.SATARDAY
  ]

  const { days, id, onDayClick } = props

  const handleDayClick = (day: DAYS_OF_WEEK) => () => {
    onDayClick(day)
  }

  return (
    <div className='flex'>
      {daysOfWeek.map(it => {
        const classes = classNames('day-of-week p1 cursor--pointer', {
          'bg-light-grey2 font-grey2': !days.includes(it),
          'bg-green font-white': days.includes(it)
        })

        return (
          <div className={classes} key={`${it}-${id}`} onClick={handleDayClick(it)}>
            {capitalToUpperCase(it as string)}
          </div>
        )
      })}
    </div>
  )
}

export default DaysOfWeek



// WEBPACK FOOTER //
// ./src/components/services/edit/working-hours/DaysOfWeek.tsx